// @ts-nocheck
/* eslint-disable */

import * as Types from '../../../graphql/v3/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SmartInfoMinPurchaseQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type SmartInfoMinPurchaseQuery = { __typename?: 'Query', smartInfo: { __typename?: 'SubscriptionInfo', minPurchaseCondition: any } };


export const SmartInfoMinPurchaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SmartInfoMinPurchase"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"smartInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minPurchaseCondition"}}]}}]}}]} as unknown as DocumentNode;
export function useSmartInfoMinPurchaseQuery(baseOptions?: Apollo.QueryHookOptions<SmartInfoMinPurchaseQuery, SmartInfoMinPurchaseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SmartInfoMinPurchaseQuery, SmartInfoMinPurchaseQueryVariables>(SmartInfoMinPurchaseDocument, options);
      }
export function useSmartInfoMinPurchaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SmartInfoMinPurchaseQuery, SmartInfoMinPurchaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SmartInfoMinPurchaseQuery, SmartInfoMinPurchaseQueryVariables>(SmartInfoMinPurchaseDocument, options);
        }
export function useSmartInfoMinPurchaseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SmartInfoMinPurchaseQuery, SmartInfoMinPurchaseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SmartInfoMinPurchaseQuery, SmartInfoMinPurchaseQueryVariables>(SmartInfoMinPurchaseDocument, options);
        }
export type SmartInfoMinPurchaseQueryHookResult = ReturnType<typeof useSmartInfoMinPurchaseQuery>;
export type SmartInfoMinPurchaseLazyQueryHookResult = ReturnType<typeof useSmartInfoMinPurchaseLazyQuery>;
export type SmartInfoMinPurchaseSuspenseQueryHookResult = ReturnType<typeof useSmartInfoMinPurchaseSuspenseQuery>;